import { axiosInstance } from '../utils/axiosinstance';

// Types for resource data
export interface Resource {
  _id: string;
  id: string;
  title: string;
  description: string;
  resourceType: string;
  link: string;
  categoryId: {
    _id: string;
    name: string;
  };
  createdAt: string;
  updatedAt: string;
  __v: number;
}

export interface ResourcesResponse {
  success: boolean;
  message?: string;
  data: Resource[];
  pagination: {
    currentPage: number;
    totalPages: number;
    totalItems: number;
    itemsPerPage: number;
    hasNextPage: boolean;
    hasPrevPage: boolean;
    nextPage: number | null;
    prevPage: number | null;
  };
}

export interface SingleResourceResponse {
  success: boolean;
  message?: string;
  data: {
    resource: Resource;
  };
}

export interface CreateResourceRequest {
  title: string;
  description: string;
  resourceType: string;
  link: string;
  categoryId: string;
}

export interface UpdateResourceRequest {
  title?: string;
  description?: string;
  resourceType?: string;
  link?: string;
  categoryId?: string;
}

export interface ResourcesParams {
  page?: number;
  limit?: number;
  categoryId?: string;
  resourceType?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

// Resource API functions
export const resourceApi = {
  // Get all resources with pagination
  getResources: async (params?: ResourcesParams): Promise<ResourcesResponse> => {
    const token = localStorage.getItem('adminToken');
    
    const response = await axiosInstance.get('/api/v1/resources', {
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {
        page: params?.page || 1,
        limit: params?.limit || 10,
        category: params?.categoryId, // Changed from categoryId to category
        type: params?.resourceType, // Changed from resourceType to type
      }
    });
    
    return response.data;
  },

  // Get single resource details
  getResourceById: async (id: string): Promise<SingleResourceResponse> => {
    const token = localStorage.getItem('adminToken');
    
    const response = await axiosInstance.get(`/api/v1/resources/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    
    return response.data;
  },

  // Create new resource
  createResource: async (resourceData: CreateResourceRequest): Promise<SingleResourceResponse> => {
    const token = localStorage.getItem('adminToken');
    
    const response = await axiosInstance.post('/api/v1/resources', resourceData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    return response.data;
  },

  // Update resource details
  updateResource: async (id: string, updateData: UpdateResourceRequest): Promise<SingleResourceResponse> => {
    const token = localStorage.getItem('adminToken');
    
    const response = await axiosInstance.put(`/api/v1/resources/${id}`, updateData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    return response.data;
  },

  // Delete a resource
  deleteResource: async (id: string): Promise<{ success: boolean; message?: string }> => {
    const token = localStorage.getItem('adminToken');
    
    const response = await axiosInstance.delete(`/api/v1/resources/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    
    return response.data;
  },
};